import styled from 'styled-components';

export const BannersRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .MuiAlert-message {
        font-size: 12px;
        line-height: 1.4;
    }
`;
